<!-- template -->
<template>
  <div class="sign__page">
    <p class="sign__page__title">Жеке кабинет</p>
    <p>Телефон номер теріңіз</p>
    <form class="sign__page__block" @submit.prevent="login_sign">
<!--      <input type="text" placeholder="Введите телефон" v-model="phone" />-->
      <masked-input class="sms__digits" v-model.trim="phone" mask="8(111) 111-11-11" />
      <button type="submit" class="button"><p>Войти</p></button>

      <a href="https://halalsogym.kz">Назад</a>
    </form>
  </div>
</template>

<!-- scripts -->
<script>
import { mapActions } from "vuex";

import MaskedInput from 'vue-masked-input'
export default {
  components: {
    MaskedInput
  },
  data() {
    return {
      phone: "",
    };
  },
  mounted() {
    if (localStorage.getItem("phone_number")) {
      this.get_profile();
    }
  },
  methods: {
    uploadImage(e) {
      const file = e.target.files[0]

      console.log(file)
      this.$refs.img.value = null
    },
    ...mapActions(["SIGN_IN_USER"]),
    login_sign() {
     localStorage.setItem('phone_number',this.phone);
     this.$router.push("/user");
    },
    get_profile() {
      this.$router.push("/user");
    },
  },
};
</script>

<style scoped lang="scss">
.sign__page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;

  @media only screen and (max-width: 764px) {
    width: 100%;
  }
  .sign__page__title {
    font-weight: bold;
    font-size: 26px;
    margin-bottom: 20px;
    color: #333;
    @media only screen and (max-width: 900px) {
      font-size: 16px;
    }
  }
  .sign__page__block {
    display: flex;
    flex-direction: column;
    input {
      width: 300px;
      padding: 20px;
      margin-bottom: 20px;
      border: 1px solid #ccc;
      @media only screen and (max-width: 764px) {
        width: 100%;
      }
    }
    ::placeholder {
      color: #333;
    }
    button {
      cursor: pointer;
      text-transform: uppercase;
      width: 300px;
      outline: none;
      border: none;
      background-color: cornflowerblue;
      padding: 20px;
      @media only screen and (max-width: 764px) {
        width: 250px;
      }
      p {
        color: white;
        font-weight: bold;
        margin-bottom: 0;
      }
    }
    button:hover {
      background-color: #285bb6;
    }
  }
}
</style>
